import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  LinkConsentsDialog,
  LinkConsentsDialogCallbackInput,
  LinkConsentsDialogUniqueProps,
} from '../LinkConsentsDialog';

const { useDialogForContext, useDialog: useLinkConsentsDialog } =
  getDialogHooks<
    LinkConsentsDialogUniqueProps,
    LinkConsentsDialogCallbackInput
  >(LinkConsentsDialog);

export const useLinkConsentsDialogForContext = useDialogForContext;
export default useLinkConsentsDialog;
